import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { find } from 'lodash';

import { LampsSelectedService } from '../../../services/lamps-selected.service';
import { SidebarService } from '@app/shared/services/sidebar.service';
import { ScenarioPanelComponent } from '../../scenario-panel/scenario-panel.component';
import { Recommendation } from '@app/shared/constants';
import { RecommendationEnum } from '@app/shared/enums';

@Component({
  selector: 'app-street-light-planner-manual',
  templateUrl: './street-light-planner-manual.component.html',
  styleUrls: [],
})
export class StreetLightPlannerManualComponent implements OnInit {
  @Output() maxStepChange = new EventEmitter<number>();
  @Output() stepChange = new EventEmitter<number>();
  @Output() backChange = new EventEmitter<Function>();
  @Output() nextChange = new EventEmitter<Function>();
  @Output() resetEvent = new EventEmitter();

  private maxStep = 2;

  constructor(private lampsSelectedService: LampsSelectedService, private sidebarService: SidebarService) {}

  public ngOnInit(): void {
    this.maxStepChange.emit(this.maxStep);
    this.stepChange.emit(this.maxStep);
    this.backChange.emit(this.back);
    this.nextChange.emit(this.next);
  }

  private back = (): void => {
    this.resetEvent.emit();
  };

  private next = (): void => {
    if (this.lampsSelectedService.selectedLampsLength > 0) {
      this.sidebarService.showComponent(ScenarioPanelComponent, {
        budget: 0,
        recommendationType: RecommendationEnum[3],
        recommendationTypeId: find(Recommendation, (value) => value.type.toLowerCase() === 'Manual'.toLowerCase())?.id,
        isSameManufacturer: false,
      });
    }
  };
}
